
export const scrollToElement = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        element.focus();
    }
};



export const getActiveUyoImageUrl = (uyoImageUrl, selectedFaceplateImageUrl) => (
    (uyoImageUrl && selectedFaceplateImageUrl === uyoImageUrl) ? uyoImageUrl : ''
);
